import React from "react";
import { ONLINE, UNAVAILABLE, MAINTENANCE } from "./../StatusOptions";
import {
  ONLINE_MAIN_LIGHT,
  ONLINE_LEFT_LIGHT,
  ONLINE_RIGHT_LIGHT,
  MAINTENANCE_LIGHT,
  UNAVAILABLE_LIGHT
} from "./DefinitionSVG";

export default ({ status }) => {
  let mainColor;
  let leftColor;
  let rightColor;
  let cloudMood;
  if (status === ONLINE) {
    mainColor = ONLINE_MAIN_LIGHT;
    leftColor = ONLINE_LEFT_LIGHT;
    rightColor = ONLINE_RIGHT_LIGHT;
    cloudMood = "happy-cloud";
  } else if (status === MAINTENANCE) {
    mainColor = leftColor = rightColor = MAINTENANCE_LIGHT;
    cloudMood = "sad-cloud";
  } else if (status === UNAVAILABLE) {
    mainColor = leftColor = rightColor = UNAVAILABLE_LIGHT;
    cloudMood = "sad-cloud";
  }
  return (
    <svg
      className="cloud-svg"
      height="130"
      width="130"
      viewBox="0 0 640 480"
      preserveAspectRatio="xMidYMid meet"
    >
      <defs>
        <radialGradient id={ONLINE_MAIN_LIGHT} spreadMethod="pad">
          <stop offset="0" stopColor="#ffffff">
            <animate
              attributeName="offset"
              dur="1000ms"
              values=".25; .15; .0; .0; .0; .0; .0; .0; .0; .0"
              repeatCount="indefinite"
              begin="0ms;op.end+400ms"
            />
          </stop>
          <stop offset="0.15" stopColor="#03a40b">
            <animate
              attributeName="offset"
              dur="1000ms"
              values=".4; .37; .35; .3; .3; .3; .3; .3; .3; .3"
              repeatCount="indefinite"
              begin="0ms;op.end+400ms"
            />
            <animate
              attributeName="stop-color"
              dur="1000ms"
              values={`#03a40b; #03a40b00; #03a40b00; #03a40b00`}
              repeatCount="indefinite"
              begin="0ms;op.end+400ms"
            />
          </stop>
          <stop offset="1" stopColor="#2b2b2b00">
            <animate
              attributeName="offset"
              dur="1000ms"
              values="1; .9; .7; 0; 0; 0; 0; 0; 0; 0"
              repeatCount="indefinite"
              begin="0ms;op.end+400ms"
            />
          </stop>
        </radialGradient>
        <radialGradient id={ONLINE_LEFT_LIGHT} spreadMethod="pad">
          <stop offset="0" stopColor="#ffffff">
            <animate
              attributeName="offset"
              dur="1600ms"
              values=".25; .15; .0; .0; .0; .0; .0; .0; .0; .0; .0; .0"
              repeatCount="indefinite"
              begin="500ms;op.end+400ms"
            />
          </stop>
          <stop offset="0.15" stopColor="#03a40b">
            <animate
              attributeName="offset"
              dur="1600ms"
              values=".4; .37; .35; .3; .3; .3; .3; .3; .3; .3; .3"
              repeatCount="indefinite"
              begin="500ms;op.end+400ms"
            />
            <animate
              attributeName="stop-color"
              dur="1600ms"
              values={`#03a40b; #03a40b00; #03a40b00; #03a40b00`}
              repeatCount="indefinite"
              begin="500ms;op.end+400ms"
            />
          </stop>
          <stop offset="1" stopColor="#2b2b2b00">
            <animate
              attributeName="offset"
              dur="1600ms"
              values="1; .9; .7; 0; 0; 0; 0; 0; 0; 0; 0"
              repeatCount="indefinite"
              begin="500ms;op.end+400ms"
            />
          </stop>
        </radialGradient>
        <radialGradient id={ONLINE_RIGHT_LIGHT} spreadMethod="pad">
          <stop offset="0" stopColor="#ffffff">
            <animate
              attributeName="offset"
              dur="700ms"
              values=".25; .15; .0; .0; .0; .0; .0"
              repeatCount="indefinite"
              begin="200ms;op.end+600ms"
            />
          </stop>
          <stop offset="0.15" stopColor="#03a40b">
            <animate
              attributeName="offset"
              dur="700ms"
              values=".4; .37; .35; .3; .3; .3; .3"
              repeatCount="indefinite"
              begin="200ms;op.end+600ms"
            />
            <animate
              attributeName="stop-color"
              dur="700ms"
              values={`#03a40b; #03a40b00; #03a40b00; #03a40b00`}
              repeatCount="indefinite"
              begin="200ms;op.end+600ms"
            />
          </stop>
          <stop offset="1" stopColor="#2b2b2b00">
            <animate
              attributeName="offset"
              dur="700ms"
              values="1; .9; .7; 0; 0; 0; 0"
              repeatCount="indefinite"
              begin="200ms;op.end+600ms"
            />
          </stop>
        </radialGradient>
        <radialGradient id={MAINTENANCE_LIGHT} spreadMethod="pad">
          <stop offset="0" stopColor="#ffffff">
            <animate
              attributeName="offset"
              dur="800ms"
              values=".25; .15; .0; .0; .0; .0; .0; .0; .0; .0"
              repeatCount="indefinite"
              begin="0ms;"
            />
          </stop>
          <stop offset="0.15" stopColor="#ffd900">
            <animate
              attributeName="offset"
              dur="800ms"
              values=".3; .27; .25; .2; .2; .2; .2; .2; .2; .2"
              repeatCount="indefinite"
              begin="0ms;"
            />
            <animate
              attributeName="stop-color"
              dur="800ms"
              values={`#ffd900; #ffd90000; #ffd90000; #ffd90000`}
              repeatCount="indefinite"
              begin="0ms;"
            />
          </stop>
          <stop offset="1" stopColor="#2b2b2b00">
            <animate
              attributeName="offset"
              dur="800ms"
              values="0.8; .6; .5; 0; 0; 0; 0; 0; 0; 0"
              repeatCount="indefinite"
              begin="0ms;"
            />
          </stop>
        </radialGradient>
        <radialGradient id={UNAVAILABLE_LIGHT} spreadMethod="pad">
          <stop offset="0" stopColor="#ffffff" />
          <stop offset="0.2" stopColor="#b90a0a" />
          <stop offset="0.7" stopColor="#2b2b2b00" />
        </radialGradient>
      </defs>
      <g className="layer">
        <g id="svg_37" className={cloudMood}>
          <ellipse
            cx="216.5"
            cy="190.5"
            fill="#8cbde8"
            id="svg_30"
            rx="90"
            ry="90"
            stroke="#4c4c4c"
            strokeWidth="0"
          />
          <ellipse
            cx="426.5"
            cy="178.5"
            fill="#8cbde8"
            id="svg_32"
            rx="90"
            ry="90"
            stroke="#4c4c4c"
            strokeWidth="0"
          />
          <ellipse
            cx="305.5"
            cy="190.5"
            fill="#8cbde8"
            id="svg_35"
            rx="90"
            ry="90"
            stroke="#4c4c4c"
            strokeWidth="0"
          />
          <ellipse
            cx="316.5"
            cy="131.5"
            fill="#8cbde8"
            id="svg_34"
            rx="90"
            ry="90"
            stroke="#4c4c4c"
            strokeWidth="0"
          />
        </g>
        <rect
          fill="#2b2b2b"
          height="276.99999"
          id="svg_1"
          rx="10"
          ry="10"
          stroke="#4c4c4c"
          strokeWidth="0"
          width="142"
          x="248.75"
          y="143.50001"
        />
        <ellipse
          className="status-main"
          cx="319.75"
          cy="347"
          fill={`url(#${mainColor})`}
          id="status_1"
          rx="70"
          ry="70"
          stroke="#000000"
          strokeWidth="0"
        />
        <rect
          fill="#ffffff"
          height="28"
          id="svg_7"
          stroke="#4c4c4c"
          strokeWidth="0"
          width="98"
          x="270.75"
          y="211.5"
        />
        <rect
          fill="#ffffff"
          height="28"
          id="svg_8"
          stroke="#4c4c4c"
          strokeWidth="0"
          width="98"
          x="270.75"
          y="169.5"
        />
        <rect
          fill="#2b2b2b"
          height="192"
          id="svg_15"
          rx="10"
          ry="10"
          stroke="#4c4c4c"
          strokeWidth="0"
          width="100"
          x="136.75"
          y="221"
        />
        <ellipse
          className="status-right"
          cx="186.75"
          cy="362.05415"
          fill={`url(#${rightColor})`}
          id="status_2"
          rx="35"
          ry="35"
          stroke="#000000"
          strokeWidth="0"
        />
        <rect
          fill="#ffffff"
          height="19.40794"
          id="svg_17"
          stroke="#4c4c4c"
          strokeWidth="0"
          width="69.01409"
          x="152.24296"
          y="268.13356"
        />
        <rect
          fill="#ffffff"
          height="19.40794"
          id="svg_18"
          stroke="#4c4c4c"
          strokeWidth="0"
          width="69.01409"
          x="152.24296"
          y="239.02165"
        />
        <rect
          fill="#2b2b2b"
          height="192"
          id="svg_20"
          rx="10"
          ry="10"
          stroke="#4c4c4c"
          strokeWidth="0"
          width="100"
          x="403.25"
          y="221"
        />
        <ellipse
          className="status-left"
          cx="453.25"
          cy="362.05415"
          fill={`url(#${leftColor})`}
          id="status_3"
          rx="35"
          ry="35"
          stroke="#000000"
          strokeWidth="0"
        />
        <rect
          fill="#ffffff"
          height="19.40794"
          id="svg_22"
          stroke="#4c4c4c"
          strokeWidth="0"
          width="69.01409"
          x="418.74296"
          y="268.13356"
        />
        <rect
          fill="#ffffff"
          height="19.40794"
          id="svg_23"
          stroke="#4c4c4c"
          strokeWidth="0"
          width="69.01409"
          x="418.74296"
          y="239.02165"
        />
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/svg/SVGServer.js